import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';
import NamedAvatar from '../../common/NamedAvatar/index.troy';
import { Blurred } from '../../common';

import Welcome from '../Welcome/index.troy';
import ClientLogo from '../ClientLogo';

const TroyGreetings = ({ clientLogo, blur }) => (
  <div className={styles['greetings__wrapper']}>
    <div className={styles['greetings__content-wrapper']}>
      <Blurred blur={blur}>
        <div className={styles['greetings__content']}>
          <div className={styles['greetings__named-avatar']}>
            <NamedAvatar />
          </div>
          <div className={styles['greetings__welcome-wrapper']}>
            <span className={styles['greetings__from']}>
              <ClientLogo
                logo={clientLogo}
                logoClassName={styles['greetings__from-logo']}
                contentClassName={styles['greetings__from-text']}
              />
            </span>
            <Welcome className={styles['greetings__welcome-content']} />
          </div>
        </div>
      </Blurred>
    </div>
  </div>
);

TroyGreetings.propTypes = {
  welcomeText: PropTypes.string,
};

export default TroyGreetings;
